import React from 'react';
import { Button } from '@gerdau/hefesto';
import { BottomButtons, BottomContainer, BottomSummary } from './styles';
import { OrderItem } from './CheckoutOrder';

interface IItem {
  value: string;
  secondValue?: string;
  title?: string;
  tooltipText?: string;
  placement?: 'bottomLeft' | 'topLeft';
}

const BottomActionBar = ({
  item,
  primaryBtn,
  secondaryBtn,
  littleContent
}: {
  item: IItem;
  primaryBtn: {
    title: string;
    primaryEvent: () => void;
    disabled?: boolean;
    loading?: boolean;
  };
  secondaryBtn: {
    title: string;
    secondaryEvent: () => void;
    disabled?: boolean;
  };
  littleContent?: boolean;
}) => {
  return (
    <BottomContainer littleContent={littleContent}>
      <BottomSummary>
        <OrderItem
          title={item?.title ?? ''}
          value={item.value}
          secondValue={item?.secondValue}
          tooltipText={item.tooltipText}
          placement={item.placement}
        />
      </BottomSummary>

      <BottomButtons>
        <Button
          name="orderChange"
          variant="secondary"
          onClick={secondaryBtn.secondaryEvent}
          disabled={secondaryBtn.disabled}
          fullWidth
        >
          {secondaryBtn.title}
        </Button>
        <Button
          name="orderFinish"
          fullWidth
          onClick={primaryBtn.primaryEvent}
          disabled={primaryBtn.disabled}
          loading={primaryBtn.loading}
        >
          {primaryBtn.title}
        </Button>
      </BottomButtons>
    </BottomContainer>
  );
};

export default BottomActionBar;
